module.exports = __webpack_public_path__ + "static/media/screen6.cfffafb2.png";